import { render } from "./product-tech-spec.vue?vue&type=template&id=b9f5ef22"
import script from "./product-tech-spec.vue?vue&type=script&lang=js"
export * from "./product-tech-spec.vue?vue&type=script&lang=js"

import "./product-tech-spec.vue?vue&type=style&index=0&id=b9f5ef22&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__